import './App.css';
import Home from "./pages/Home";
import Accountability from '../src/pages/Accountability.js';
import Legal from '../src/pages/Legal.js';
import Login from './pages/Signin.js';
import Signup from './pages/Signup.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>  {/* Wrapping Routes inside Router */}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/investigations' element={<Accountability />} />
        <Route path='/legal' element={<Legal />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
      </Routes>
    </Router>
  );
}

export default App;
